// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2v-1";
export var movingGradient = "_2v-4";
export var movingGradientBlock = "_2v-2";
export var skeleton = "_2v-0";
export var skeletonText = "_2v-3";